export function initNeosEventItemSelected(slider) {
    document.addEventListener("Neos.NodeSelected", (event) => {
        const element = event.detail.element;

        if (!element.classList.contains("slider--card")) {
            return;
        }

        if (slider.contains(element)) {
            const elementRect = element.getBoundingClientRect();
            const sliderRect = slider.getBoundingClientRect();

            // Überprüfen, ob das Element außerhalb des sichtbaren Bereichs liegt
            const isOutOfView =
                elementRect.left < sliderRect.left ||
                elementRect.right > sliderRect.right;

            if (isOutOfView) {
                // Scrollen, wenn das Element außerhalb des Sichtbereichs liegt
                const scrollContainer = slider.querySelector(".scroll--container")
                const itemContainer = slider.querySelector(".item--container")
                const currendCardRect = element.getBoundingClientRect();
                const scrollContainerRect = scrollContainer.getBoundingClientRect();
                const cardDefaultPositionLeft = parseInt(window.getComputedStyle(itemContainer).paddingLeft, 10);
                const offset = currendCardRect.left - scrollContainerRect.left - cardDefaultPositionLeft;

                scrollContainer.scrollTo({
                    left: scrollContainer.scrollLeft + offset,
                    behavior: 'smooth'
                });
            }
        }
    });
}
